import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'CmgLoadingPepper',
})
export default class CmgLoadingPepper extends Vue {

  @Prop({ type: Number, default: 64 })
  size!: number;

  @Prop({ type: Number, default: 0 })
  shadowSize!: number;

  get backgroundStyle() {
    return {
      width: `${this.size}px`,
      height: `${this.size}px`,
      borderRadius: `${this.size / 2}px`,
      boxShadow: `0px 0px ${this.shadowSize * 1.5}px ${this.shadowSize}px rgba(0, 0, 0, 0.2)`
    };
  }

  get pepperStyle() {
    const dimension = this.size * .7;
    return {
      width: `${dimension}px`,
      height: `${dimension}px`
    };
  }

  get pepperUrl(): string {
    return this.$appStore.state.cms.images.loadingPepper.default;
  }
}
